import { useSelector } from "react-redux";

export const IDS = {
  // IMG_URL: "http://127.0.0.1:4325",
  // IMG_URL: "http://192.168.16.38:4325",
  // IMG_URL: "https://driwenode.driwe.in:4321",
  // IMG_URL: "https://node.driwe.in",
  IMG_URL: "https://driwenode.driwe.in",
  // IMG_URL: "https://driwenode.profcyma.org:4325",
  PAGE: 1,
  PERPAGE: 10,
  TOTALPAGES: 1,
  TOTAL: 1,
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  SLICESTATUS: {
    Idle: "idle",
    Loading: "loading",
    Succeeded: "succeeded",
    Failed: "failed",
  },

  Permission: {
    Roles: { List: 1, Add: 2, Edit: 3, Delete: 4 },
    Users: { List: 5, Add: 6, Edit: 7, Delete: 8 },
    Country: { List: 9, Add: 10, Edit: 11, Delete: 12 },
    State: { List: 13, Add: 14, Edit: 15, Delete: 16 },
    City: { List: 17, Add: 18, Edit: 19, Delete: 20 },
    Pincode: { List: 21, Add: 22, Edit: 23, Delete: 24 },
    Gender: { List: 25, Add: 26, Edit: 27, Delete: 28 },
    Vehicle_Category: { List: 29, Add: 30, Edit: 31, Delete: 32 },
    Banner: { List: 33, Add: 34, Edit: 35, Delete: 36 },
    About_Us: { List: 37, Add: 38, Edit: 39, Delete: 40 },
    Key_Feature: { List: 41, Add: 42, Edit: 43, Delete: 44 },
    Why_Choose_Us: { List: 45, Add: 46, Edit: 47, Delete: 48 },
    Term_Condition: { List: 49, Add: 50, Edit: 51, Delete: 52 },
    Save_Location: { List: 53, Add: 54, Edit: 55, Delete: 56 },
    Good_Type: { List: 57, Add: 58, Edit: 59, Delete: 60 },
    Faq: { List: 61, Add: 62, Edit: 63, Delete: 64 },
    App_Setup: { List: 65, Edit: 66 },
    Contact: { List: 67 },
    Enquiry: { List: 68 },
    Privacy_Policy: { List: 69, Add: 70, Edit: 71, Delete: 72 },
    Training_Video: { List: 73, Add: 74, Edit: 75, Delete: 76 },
    Booking_Cancel_Reason: { List: 77, Add: 78, Edit: 79, Delete: 80 },
    Driver: { List: 81, Edit: 83 },
    Customer: { List: 82 },
    Driver_Banner: { List: 84, Add: 85, Edit: 86, Delete: 87 },
  },
};





